import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-10 w-full rounded-md border bg-white px-3 text-sm text-neutral-ink placeholder:text-neutral-muted/60',
        'transition focus:outline-none focus:ring-2 focus:ring-blue-30',
        invalid
          ? 'border-orange focus:border-orange focus:ring-orange/30'
          : 'border-surface-line focus:border-blue',
        'disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});
